import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import ExportDataHandler from "../../../utility/ExportDataHandler";
import { formatAmount } from "../../../utility/CommonFunctions";
import TopCardDashboard from "../../Dashboard/TopCardDashboard";
import BudgetIcon from "../../../components/Icons/Sidebar/BudgetIcon";
import ODAplicationIcon from "../../../components/Icons/Sidebar/ODAplicationIcon";
import PaymentReceivedIcon from "../../../components/Icons/PaymentReceivedIcon";
import PaymentDueIcon from "../../../components/Icons/PaymentDueIcon";

export default function WorkOrder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timeoutId = useRef(null);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    WorkOrderList: [],
    searchQuery: "",
    customerIsLoading: false,
    customerCompanyIsLoading: false,
    customerCompanyList: [],
    counts: {
      totalAmount: 0,
      netReceivable: 0,
      paymentReceived: 0,
      paymentDue: 0,
    },
    customerList: [],
    siteId: filterDetails?.siteId,
    companyList: [],
    siteList: [],
  });
  const userDetails = useSelector((state) => state.root.userDetails);

  useEffect(() => {
    if (filterDetails?.year) {
      GetWorkOrderList();
    }
    if (pageStates?.companyList?.length == 0) {
      GetCompanyList();
    }
    if (pageStates?.customerList?.length == 0) {
      fetchList("", "customerIsLoading");
    }
    if (pageStates?.customerCompanyList?.length == 0) {
      fetchList("", "customerCompanyIsLoading");
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    filterDetails?.customerCompanyId,
    filterDetails?.customerId,
    pageStates?.isInitial,
    filterDetails?.selectedMonths,
  ]);

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  const GetWorkOrderList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_workOrder +
      "?" +
      MainFilterHandler({
        ...filterDetails,
        siteId: pageStates?.siteId,
        searchQuery: pageStates?.searchQuery,
      });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.workOrder?.map((item) => ({
          ...item,
          orderDate: moment(item?.date).format("DD-MM-YYYY"),
          siteName: item?.site?.name,
          customerName: item?.site?.customer?.name,
          taxableAmount: formatAmount(item?.taxableAmount || 0),
          gstAmount: formatAmount(item?.gstAmount || 0),
          totalAmount: formatAmount(item?.totalAmount || 0),
          netReceivable: formatAmount(item?.netReceivable || 0),
          paymentDue: formatAmount(item?.paymentDue || 0),
          paymentReceived: formatAmount(item?.paymentReceived || 0),
          workOrderStatus: item?.isCompleted,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          WorkOrderList: newData,
          counts: response?.data?.count,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.work_order_detail + `/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_work_order, { state: { data: data } });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "customerName", label: "Customer" },
    { value: "siteName", label: "Site" },
    { value: "workOrderNumber", label: "WO NO." },
    { value: "title", label: "Title" },
    { value: "orderDate", label: "Date" },
    { value: "taxableAmount", label: "Taxable Amount" },
    { value: "gstAmount", label: "GST Amount" },
    { value: "totalAmount", label: "Total Amount" },
    { value: "netReceivable", label: "Net Receivable" },
    { value: "paymentReceived", label: "Payment Received" },
    { value: "paymentDue", label: "Payment Due" },
    { value: "workOrderStatus", label: "Status" },
    { value: "lastBillingMonth", label: "Last Billing" },
  ];

  const ActionData = [
    ...(!(
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Coordinator"
    )
      ? [
        {
          label: "Update",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "update",
          clickHandler: HandleUpdate,
        },
      ]
      : []),
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const dateChangeHandler = (Dates) => {
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const fetchList = (inputValue, type, id) => {
    return new Promise((resolve) => {
      let baseUrl =
        type === "customerIsLoading"
          ? apiUrl.get_customer
          : apiUrl.get_customer_company;

      const queryParams = [];
      if (type !== "customerIsLoading" && id) {
        queryParams.push(`customerId=${id}`);
      }
      if (inputValue) {
        queryParams.push(`search=${inputValue}`);
      }

      let API = baseUrl;
      if (queryParams.length > 0) {
        API += `?${queryParams.join("&")}`;
      }

      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        [type]: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData =
              type === "customerIsLoading"
                ? response?.data?.customer.map((customer) => ({
                  value: customer?.id,
                  label: customer?.name,
                }))
                : response?.data?.customerCompany.map((customer) => ({
                  value: customer?.id,
                  label: customer?.companyName,
                }));

            setPageStates((prev) => ({
              ...prev,
              ...(type === "customerIsLoading"
                ? { customerList: formattedData }
                : { customerCompanyList: formattedData }),
              [type]: false,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    companyList: pageStates?.companyList,
    fetchCustomerList: (search) => fetchList(search, "customerIsLoading"),
    customerIsLoading: pageStates.customerIsLoading,
    customerList: pageStates.customerList,
    fetchCustomerCompanyList: (search, id = null) =>
      fetchList(search, "customerCompanyIsLoading", id),
    customerCompanyIsLoading: pageStates.customerCompanyIsLoading,
    customerCompanyList: pageStates.customerCompanyList,
    monthList: [
      { id: "Jan", name: "January" },
      { id: "Feb", name: "February" },
      { id: "Mar", name: "March" },
      { id: "Apr", name: "April" },
      { id: "May", name: "May" },
      { id: "Jun", name: "June" },
      { id: "Jul", name: "July" },
      { id: "Aug", name: "August" },
      { id: "Sep", name: "September" },
      { id: "Oct", name: "October" },
      { id: "Nov", name: "November" },
      { id: "Dec", name: "December" },
    ],
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
        ...(!type && { customerId: data?.customerId?.value }),
        ...(!type && { customerCompanyId: data?.customerCompanyId?.value }),
        ...(!type && { selectedMonths: data?.month }),
        ...(type === "month" && { selectedMonths: data?.month }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleExport = () => {
    let filterData = {
      exportDataType: "workOrder",
      searchQuery: pageStates?.searchQuery,
      ...filterDetails,
    };
    delete filterData?.currentPage;
    delete filterData?.pageSize;
    delete filterData?.count;
    delete filterData?.totalPages;
    ExportDataHandler(filterData);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  const formatFull = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(value);

  const formatCompact = (value) => {
    value = Number(value);

    if (!value || value === 0) return "₹0";

    const abs = Math.abs(value);

    if (abs >= 10000000) return `₹${(value / 10000000).toFixed(2)}Cr`;
    if (abs >= 100000) return `₹${(value / 100000).toFixed(2)}L`;
    if (abs >= 1000) return `₹${(value / 1000).toFixed(2)}K`;

    return `₹${value}`;
  };

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Work Order"}
          buttonText={"Add Work Order"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
          buttonIcon={<PlusIcon />}
          buttonLink={
            !(
              userDetails?.type === 2 ||
              userDetails?.designation?.name === "Coordinator"
            ) && RoutesLink?.add_work_order
          }
          showDefaultDate={true}
        />
        <div className="card mb-4">
          <div className="card-body">
            {/* WorkOrder Summary Cards */}
            <div className="row g-3 mb-1">
              {/* Total PO Value */}
              <TopCardDashboard
                title="TOTAL WORK ORDER VALUE"
                count={formatCompact(pageStates?.counts?.totalAmount)}
                icon={<BudgetIcon />}
              >
                {formatFull(pageStates?.counts?.totalAmount)}
              </TopCardDashboard>

              {/* Net Receivable */}
              <TopCardDashboard
                title="NET RECEIVABLE"
                count={formatCompact(pageStates?.counts?.netReceivable)}
                icon={<ODAplicationIcon />}
              >
                {formatFull(pageStates?.counts?.netReceivable)}
              </TopCardDashboard>

              {/* Payment Received */}
              <TopCardDashboard
                title="PAYMENT RECEIVED"
                count={formatCompact(pageStates?.counts?.paymentReceived)}
                icon={<PaymentReceivedIcon />}
              >
                {formatFull(pageStates?.counts?.paymentReceived)}
              </TopCardDashboard>

              {/* Payment Due */}
              <TopCardDashboard
                title="PAYMENT DUE"
                count={formatCompact(pageStates?.counts?.paymentDue)}
                icon={<PaymentDueIcon />}
              >
                {formatFull(pageStates?.counts?.paymentDue)}
              </TopCardDashboard>
            </div>
            <FilterComponent
              handleSearch={handleSearchChange}
              filterArray={sortList}
              handleData={handleSortData}
              sortHandler={handleSortData}
              pageStates={pageStates}
              handleExport={
                pageStates?.WorkOrderList?.length > 0 ? handleExport : null
              }
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              getSite={GetSiteList}
              getCompany={GetCompanyList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.WorkOrderList}
              ActionData={ActionData}
              currentPage={filterDetails?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={filterDetails?.totalPages}
              count={filterDetails?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={filterDetails?.pageSize}
            />
          </div>
        </div>
      </div>
    </>
  );
}
